/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Audiences_TitleInputs */

const en_directory_taxonomy_audiences_title = /** @type {(inputs: Directory_Taxonomy_Audiences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find products for the people doing the work`)
};

const zh_directory_taxonomy_audiences_title = /** @type {(inputs: Directory_Taxonomy_Audiences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为真正完成工作的人找到产品`)
};

/**
* | output |
* | --- |
* | "Find products for the people doing the work" |
*
* @param {Directory_Taxonomy_Audiences_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_audiences_title = /** @type {((inputs?: Directory_Taxonomy_Audiences_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Audiences_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_audiences_title(inputs)
	return zh_directory_taxonomy_audiences_title(inputs)
});
export { directory_taxonomy_audiences_title as "directory.taxonomy.audiences.title" }